import React, { useEffect, useRef } from "react"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"

export default function SubNavigation({ current, id }) {
  const menu = findObject(menuData, "name", id).children
  const location = menu.findIndex(item => item.id.includes(current))
  const activeItem = useRef()

  const handleScroll = () => {
    var height = document.documentElement.scrollHeight - window.innerHeight
    var scrollY = window.pageYOffset
    var progress = Math.round((scrollY / height) * 100)
    if (activeItem.current) {
      activeItem.current.style.width = progress + "%"
    }
  }

  const setActive = name => {
    if (current === name) {
      return "sub-navigation--active"
    } else if (!current) {
      return "sub-navigation--active"
    } else {
      return null
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  })

  return (
    <nav className="sub-navigation util__desktop-only">
      <ul>
        {menu.map((item, index) => {
          return (
            <li
              key={index}
              className={setActive(item.id, index)}
              style={{ flex: 100 / menu.length }}
            >
              <div
                className={
                  index < location
                    ? "sub-navigation__progress sub-navigation__progress--full"
                    : "sub-navigation__progress"
                }
                ref={item.id === current ? activeItem : null}
              />
              <Link className="title--micro title--uppercase" to={item.href}>
                {item.name}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
